'use client';

/**
 * Chat streaming indicator component
 * Shows tool progress or generic working state
 */

import React, { memo } from 'react';
import { ToolProgressShimmer } from './ToolProgressShimmer';
import { CHAT_LAYOUT, AVATARS } from '../../styles/chat-layout';

interface ChatStreamingIndicatorProps {
  toolProgress: { label: string } | null;
  showWorkingShimmer: boolean;
  isStreaming: boolean;
  botAvatarUrl?: string;
}

function ChatStreamingIndicatorComponent({
  toolProgress,
  showWorkingShimmer,
  isStreaming,
  botAvatarUrl,
}: ChatStreamingIndicatorProps) {
  if (!((toolProgress || showWorkingShimmer || isStreaming))) {
    return null;
  }

  return (
    <div className={CHAT_LAYOUT.inputWrapper}>
      <div className={`${CHAT_LAYOUT.messageItem} ${CHAT_LAYOUT.messageItemBot}`}>
        {botAvatarUrl && (
          <img
            src={botAvatarUrl}
            alt="Meridian"
            className={AVATARS.image}
          />
        )}
        {toolProgress ? (
          <ToolProgressShimmer label={toolProgress.label} />
        ) : showWorkingShimmer ? (
          <ToolProgressShimmer label="Working…" />
        ) : (
          <ToolProgressShimmer label="Writing…" />
        )}
      </div>
    </div>
  );
}

export const ChatStreamingIndicator = memo(ChatStreamingIndicatorComponent);
